import axios from 'axios'

export default {
    checkResponse(response) {
        if (response) {
            if (!!response.data.deactivated) {
                if (window.location.pathname != '/login') {
                    return window.location.href = '/login';
                }
            } else {
                return response.data
            }
        } else {
            toastr['error']('Ошибка', 'Ошибка');

            return window.location.href = '/login';
        }
    },
    getSources(page, sort, search, range, user, isAllPages, group, pageSize) {
        var url = '/sources/list?page=' + page + '&sortBy=' + sort.sortBy + '&sortDesc=' + sort.sortDesc + '&start=' + range.start + '&end=' + range.end + '&user=' + user + '&search=' + search + '&allPages=' + isAllPages + '&group=' + group + '&pageSize=' + pageSize;

        return axios.get(url)
            .then(response => {

                return this.checkResponse(response)
            })
    },
    deleteSource(id) {

        return axios.post('/sources/delete/' + id)
            .then(response => {

                return this.checkResponse(response)
            })
    },
    saveSource(source) {

        return axios.post('/sources/save', source)
            .then(response => {

                return this.checkResponse(response)
            })
    },
    updateSource(source) {

        return axios.post('/sources/update/' + source.id, source)
            .then(response => {

                return this.checkResponse(response)
            })
    },
    getGroups() {
        return axios.get('/sources/groups')
            .then(response => {

                return this.checkResponse(response);
            })
    }
}



// WEBPACK FOOTER //
// ./resources/js/services/sourcesDataService.js